module.exports = __webpack_public_path__ + "static/media/message-square.59dfe29c.svg";